import { Input } from '@creditornot/cb-input';
import React from 'react';
import { Field } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { RFFFieldErrorWrapper } from 'common/components';
import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { EndOfDayFormValues } from 'modules/campaigns/types';

import CampaignFormItemLayout from '../../CampaignFormItemLayout';

const StyledInputsContainer = styled.div`
  flex: 1;
  display: flex;
  gap: 16px;
  align-items: center;
  margin-block-start: 12px;
  width: 100%;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    flex-direction: column;
    align-items: stretch;
  }
`;
const StyledInput = styled(Input)`
  width: 175px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    width: 100%;
  }
`;
const EndOfDayItemsCountField = () => {
  const intl = useIntl();

  return (
    <CampaignFormItemLayout
      title={<FormattedMessage id="campaigns.form.end-of-day-items-count.title" />}
      subtitle={<FormattedMessage id="campaigns.form.end-of-day-items-count.description" />}
      value={
        <StyledInputsContainer>
          <Field<EndOfDayFormValues['endOfDayItemsCount']> name="endOfDayItemsCount" type="number">
            {field => (
              <RFFFieldErrorWrapper field={field}>
                {input => {
                  return (
                    <StyledInput
                      {...input}
                      value={input.value}
                      suffixText={intl.formatMessage({
                        id: 'campaigns.form.end-of-day-items-count.input-suffix',
                      })}
                      // by default, the number input will increment/decrement by 1 when you scroll the mouse wheel inside it
                      // this is not the desired behavior for this input, so we prevent it here
                      onWheel={e => 'blur' in e.target && typeof e.target.blur === 'function' && e.target.blur()}
                    />
                  );
                }}
              </RFFFieldErrorWrapper>
            )}
          </Field>
        </StyledInputsContainer>
      }
    />
  );
};

export default EndOfDayItemsCountField;
